import type { AsyncThunk, AsyncThunkOptions, AsyncThunkPayloadCreator } from '@reduxjs/toolkit';
import { createAsyncThunk, type ThunkApiConfig } from './typedFunctions';
import thunkErrorSerializer from './thunkErrorSerializer';

/**
 * A wrapper for any async thunk that makes an axios request.
 * Same API and types as createAsyncThunk, with serializeError defaulting to thunkErrorSerializer
 * so the error payload from fusion is passed to the reducer.
 */
function createAxiosThunk<Returned = unknown, ThunkArg = void>(
  typePrefix: string,
  payloadCreator: AsyncThunkPayloadCreator<Returned, ThunkArg, ThunkApiConfig>,
  options: AsyncThunkOptions<ThunkArg, ThunkApiConfig> = {}
): AsyncThunk<Returned, ThunkArg, ThunkApiConfig> {
  return createAsyncThunk(typePrefix, payloadCreator, {
    ...options,
    serializeError: options.serializeError ?? thunkErrorSerializer,
  });
}

export default createAxiosThunk;
